import { Beaker, Calculator, BookOpen, Palette } from "lucide-react"

interface ClassProgress {
  subject: string
  grade: string
  module: string
  progress: number
  icon: string
  color: string
}

interface ClassProgressOverviewProps {
  data: ClassProgress[]
}

const iconMap: Record<string, any> = {
  Beaker,
  Calculator,
  BookOpen,
  Palette,
}

export function ClassProgressOverview({ data }: ClassProgressOverviewProps) {
  return (
    <div className="bg-card rounded-3xl p-6 shadow-lg border border-border flex flex-col">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-bold text-foreground">Class Progress</h3>
        <a className="text-sm font-semibold text-[#21a193] hover:text-[#1a8378] transition-colors" href="#">
          View All
        </a>
      </div>

      <div className="space-y-5 flex-1 overflow-y-auto pr-2">
        {data.map((item, index) => {
          const Icon = iconMap[item.icon]
          return (
            <div key={index} className="group">
              <div className="flex justify-between items-end mb-2">
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${item.color}10`, color: item.color }}
                  >
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-foreground text-sm">{item.subject}</h4>
                    <p className="text-xs text-muted-foreground">
                      {item.grade} - {item.module}
                    </p>
                  </div>
                </div>
                <span className="text-sm font-bold" style={{ color: item.color }}>
                  {item.progress}%
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-1000"
                  style={{ width: `${item.progress}%`, backgroundColor: item.color }}
                ></div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
